import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DialogData } from '../dialog.interface'

@Component({
  selector: 'app-dtcm-missing-fields-dialog',
  templateUrl: './dtcm.missing.fields.dialog.component.html',
  styleUrls: ['../dialog.component.scss'],
  imports: [CommonModule]
})
export class DTCMMissingFieldsDialog {
  /** Injectable dialog reference */
  protected readonly dialogRef: MatDialogRef<DTCMMissingFieldsDialog> = inject(MatDialogRef<DTCMMissingFieldsDialog>)
  /** Injectable dialog data */
  protected readonly data: DialogData = inject(MAT_DIALOG_DATA)

  proceed(slug) {
    this.dialogRef.close(slug)
  }
}
